import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { publicColors, publicContainerSx, publicFontFamily, publicHeroFontSx } from './publicTheme';

const painStats = [
    { stat: '???', label: 'Margem real por peça', sub: 'Quando o preço é no feeling' },
    { stat: '0%', label: 'Visibilidade de falhas', sub: 'Sem histórico por impressora' },
    { stat: 'Caos', label: 'Produção vs. vendas', sub: 'Planilha não cruza os dois' },
];

const Banner = () => (
    <Box
        id="top"
        component="section"
        sx={{
            bgcolor: publicColors.surface,
            borderBottom: `1px solid ${publicColors.border}`,
            pt: { xs: 14, md: 16 },
            pb: { xs: 8, md: 12 },
            fontFamily: publicFontFamily,
        }}
    >
        <Box sx={{ ...publicContainerSx, px: { xs: 2, md: 3 } }}>
            <Stack spacing={3} alignItems="center" textAlign="center">
                <Typography
                    component="p"
                    sx={{
                        fontFamily: publicFontFamily,
                        fontSize: { xs: '0.8rem', sm: '0.875rem' },
                        fontWeight: 700,
                        letterSpacing: '0.14em',
                        textTransform: 'uppercase',
                        color: publicColors.primary,
                    }}
                >
                    Gestão para quem vende impressão 3D
                </Typography>

                <Box sx={{ maxWidth: 960 }}>
                    <Typography
                        component="h1"
                        sx={{
                            ...publicHeroFontSx,
                            fontWeight: 800,
                            fontSize: { xs: '2.75rem', sm: '3.5rem', md: '4.25rem', lg: '4.75rem' },
                            color: publicColors.ink,
                            mb: 1,
                        }}
                    >
                        Você sabe quanto realmente ganha
                    </Typography>
                    <Typography
                        component="p"
                        aria-hidden
                        sx={{
                            ...publicHeroFontSx,
                            fontWeight: 800,
                            fontSize: { xs: '2.75rem', sm: '3.5rem', md: '4.25rem', lg: '4.75rem' },
                            color: publicColors.danger,
                            mb: 2,
                        }}
                    >
                        com cada venda?
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: publicFontFamily,
                            fontSize: { xs: '1.125rem', md: '1.35rem' },
                            fontWeight: 500,
                            color: publicColors.inkMuted,
                            lineHeight: 1.65,
                            maxWidth: 680,
                            mx: 'auto',
                        }}
                    >
                        Organize vendas, orçamentos, pedidos, produção, custos, estoque e finanças em um só lugar.
                        <br />
                        Do WhatsApp à loja parceira. Da feira livre ao marketplace.
                        <br />
                        <br />
                        <Box component="span" sx={{ color: publicColors.ink, fontWeight: 700, textTransform: 'uppercase' }}>
                            Venda por qualquer canal, gerencie em um só lugar!
                        </Box>{' '}.
                    </Typography>
                </Box>

                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    justifyContent="center"
                    sx={{ pt: 1 }}
                >
                    <Button
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        component="a"
                        href="#precos"
                        sx={{
                            fontFamily: publicFontFamily,
                            bgcolor: publicColors.primary,
                            fontWeight: 700,
                            fontSize: '1rem',
                            px: 4,
                            py: 1.5,
                            borderRadius: 1.5,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: publicColors.primaryDark, boxShadow: 'none' },
                        }}
                    >
                        Começar grátis!
                    </Button>
                </Stack>

                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: publicFontFamily,
                        color: publicColors.inkSoft,
                        maxWidth: 520,
                        pt: 1,
                        fontWeight: 500,
                    }}
                >
                </Typography>
            </Stack>
        </Box>
    </Box>
);

export default Banner;
